import React from 'react';
import { Table } from 'antd';

/**
 * Component to display a table of allocation history where column headers are labels and cell headers are timestamps
 * @param labels {Array<string>} - The labels for the rows
 * @param series {Array<Array<number>>} - The series of data to display
 * @returns {JSX.Element}
 * @constructor
 */
const AllocationHistoryTable = ({ labels, series }) => {
  // Determine whether to show deltas
  const showDeltas = labels.length < 10;

  // Prepare columns configuration
  const columns = [
    {
      title: 'Timestamp',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 125,
      fixed: 'left',
      render: text => <div style={{fontWeight: '700'}}>{text}</div>,
    },
    ...labels.flatMap((label, index) => {
      const cols = [{
        title: label.toUpperCase(),
        dataIndex: `value${index}`,
        key: `value${index}`,
      }];
      if (showDeltas) {
        cols.push({
          title: 'Change',
          dataIndex: `delta${index}`,
          key: `delta${index}`,
        });
      }
      return cols;
    }),
  ];

  // Prepare dataSource for the Table
  const dataSource = series.map((row, rowIndex) => {
    const dataRow = { key: rowIndex, timestamp: row[0] };
    row.slice(1).forEach((value, index) => {
      dataRow[`value${index}`] = value === 0 ? '-' : `${value.toFixed(1)}%`;
      if (showDeltas && rowIndex > 0) {
        const delta = value - series[rowIndex - 1][index + 1];
        dataRow[`delta${index}`] = delta === 0 ? '-' : `${((delta / series[rowIndex - 1][index + 1]) * 100).toFixed(1)}%`;
      }
    });
    return dataRow;
  });

  return <Table
      size={'small'}
            columns={columns}
            dataSource={dataSource}
            pagination={false}
            scroll={{y: 800}}
      />


};

export default AllocationHistoryTable;
